import { render } from "./FullscreenOverlay.vue?vue&type=template&id=7712e788"
import script from "./FullscreenOverlay.vue?vue&type=script&lang=js"
export * from "./FullscreenOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__